import React from 'react';
import { Feature, IActionPointInfo } from '@tencent/workbench';
import { config } from './config';
import BaseSelectablePanelFeature from '@framework/workbench/common/feature/base-selectable-panel-feature';
import SelectablePanel from '@framework/workbench/common/components/selectable-panel';
import TemplateCard from '@framework/workbench/common/components/selectable-panel/template-card';
import { DARK_TEMPLATE, SIMPLE_TEMPLATE, MODERN_TEMPLATE, FEATURED_TEMPLATE, HOT_WORKPLACE_TEMPLATE, SUMMARY_TEMPLATE } from '@framework/workbench/common/components/selectable-panel/template-card/template-config';
import i18n from '@i18next/i18n';
import { IChangeTemplateService } from '@src/slide/application/service/change-template-service/index.interface';
import { reaction } from 'mobx';
import { IReactionDisposer } from 'mobx/lib/internal';
import { FIXED_KEYS_DOUBLE } from '../../schema/constant';
import { getAidForReport } from '@tencent/txdocs-aid';
import { fetchThumbnailById } from '@src/slide/application/service/ai-ssistant/ai-generator/fetch-template';

@Feature()
export class ChangeTemplateFeature extends BaseSelectablePanelFeature {
    public id = config.id;
    public config = config;
    public changeTemplateServiceInstance?: IChangeTemplateService;
    public initReaction: IReactionDisposer;
    private disabled = false;
    public constructor() {
        super();
        this.getAppService().editableServiceLayer?.changeTemplateService?.promise().then((module) => {
            this.changeTemplateServiceInstance = module;
            this.toolbarService.$forceUpdate();
            this.initReaction = reaction(() => module.selectedName, () => {
                this.toolbarService.$forceUpdate();
            });
        });
    }

    public getContent(info: IActionPointInfo) {
        const changeTemplateService = this.getAppService().editableServiceLayer?.changeTemplateService;
        const templatesElements = this.getTemplates(info).map(templates => ({
            name: templates.name,
            cardList: templates.list.map(item => ({
                element: <TemplateCard
                    disabled={this.disabled}
                    onDisabledChange={(disabled) => {
                        this.disabled = disabled;
                    }}
                    changeTemplateService={changeTemplateService}
                    key={item.id}
                    id={item.id}
                    needVip={item.needVip}
                    icon={item.cover}
                    getCoverSrc={this.getCoverSrc}
                    name={item.id}
                    aid={this.getAid(info)}
                    useFullPreview={this.isVipToolbar(info)}
                />,
                id: item.id,
            })),
        }));
        return <SelectablePanel
            expandHeight={this.isVipToolbar(info) ? 200 : 254}
            colNumber={6}
            showArrow={true}
            style={{
                width: 432,
            }}
            selectedId={this.changeTemplateServiceInstance?.selectedName}
            childrenElements={templatesElements} />;
    }

    private getTemplates(info: IActionPointInfo) {
        if (this.isVipToolbar(info)) {
            return [
                { name: i18n.t('精选推荐'), list: FEATURED_TEMPLATE },
                { name: i18n.t('总结报告'), list: SUMMARY_TEMPLATE },
                { name: i18n.t('职场热门'), list: HOT_WORKPLACE_TEMPLATE },
            ];
        }
        return [
            { name: i18n.t('现代'), list: MODERN_TEMPLATE },
            { name: i18n.t('简约'), list: SIMPLE_TEMPLATE },
            { name: i18n.t('深色'), list: DARK_TEMPLATE },
        ];
    }

    private getAid(info: IActionPointInfo) {
        if (this.isVipToolbar(info)) {
            const aid = getAidForReport({
                position: 'toolbarviptab',
                feature: 'template',
                apprec1: 'slide',
            });
            return aid;
        }
    }

    private isVipToolbar(info: IActionPointInfo) {
        return info.path[0] === FIXED_KEYS_DOUBLE.TOOLBAR_VIP;
    }

    private getCoverSrc = async (id): Promise<string> => {
        const changeTemplateService = await this.getAppService().editableServiceLayer?.changeTemplateService?.promise();
        try {
            if (changeTemplateService) {
                const data = await fetchThumbnailById(id);
                const src = await changeTemplateService.getCoverSrc(data);
                return src;
            }
        } catch (error) {
            window.log?.error?.(`get template thumbnail failed,  msg: ${error}`);
        }
        return '';
    };
}
